import api from 'api/api';

// Asegurar que la URL base siempre termine con /
const API_BASE = process.env.REACT_APP_BASE_URL?.endsWith('/') 
  ? process.env.REACT_APP_BASE_URL 
  : `${process.env.REACT_APP_BASE_URL}/`;

// Eliminar el /api/ ya que Django no lo usa
const BASE_URL = `${API_BASE}api/studio/payments/`;

export const createPayment = async (paymentData, sedeId = null) => {
    try {
        // Add sede_id to the payload if provided
        const payload = sedeId ? { ...paymentData, sede_id: sedeId } : paymentData;
        const response = await api.post(BASE_URL, payload);
        return response.data;
    } catch (error) {
        console.error("Error al registrar el pago:", error);
        throw error;
    }
};

export const fetchAllPayments = async (sedeParams = {}, sedeHeaders = {}) => {
    try {
        const response = await api.get(BASE_URL, { params: sedeParams, headers: sedeHeaders });
        return response.data;
    } catch (error) {
        console.error(`Error al obtener pagos: `, error);
        throw error;
    }
};

export const applyPenalty = async ({ client_id, amount }) => {
    return await api.post(BASE_URL, {
      client_id,
      membership_id: 9999, // ← después creamos una membresía especial "Penalización"
      amount,
      date_paid: new Date().toISOString(),
      valid_until: new Date().toISOString(),
    });
};

export const fetchPaymentsByClient = async (clientId, sedeParams = {}, sedeHeaders = {}) => {
    try {
        const params = { ...sedeParams, client: clientId };
        const response = await api.get(BASE_URL, { params, headers: sedeHeaders });
        return response.data;
    } catch (error) {
        console.error(`Error al obtener pagos del cliente ${clientId}:`, error);
        throw error;
    }
};

export const getPaymentsInGrace = async (sedeParams = {}, sedeHeaders = {}) => {
    try {
      const response = await api.get(BASE_URL + 'en-gracia/', { params: sedeParams, headers: sedeHeaders });
      return response.data;
    } catch (error) {
      console.error('Error al obtener clientes en periodo de gracia:', error);
      throw error;
    }
};

export const extendPaymentValidity = async (paymentId) => {
    try {
      const url = `${BASE_URL}${paymentId}/extend-vigencia/`;
      const response = await api.put(url);   // puedes mandar body vacío
      return response.data;
    } catch (error) {
      console.error('Error al extender vigencia del pago:', error);
      throw error;
    }
};